module.exports = __webpack_public_path__ + "static/media/qumedia.d47a4093.png";